import { useEffect, useState } from 'react';
import axios from 'axios';
import { useModalOpen } from '../../../hooks/useToastModalOpen.js';
import Main from '../../../component/Main.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import MonitoringMsgCmt_layer from './MonitoringMsgCmt_layer.jsx';

const SendStatMonitoringMsgData = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth() + 1;
    if (currentMonth < 10) {
        currentMonth = "0" + currentMonth;
    }

    const [searchParams, setSearchParams] = useState({
        searchYear: currentYear,
        searchMonth: currentMonth,
        searchEmog: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("useremcd") : '',
        searchGrdc: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("emoggrdc2") : '',
        searchLoca: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("emogloca") : '',
        ptmiindt: String(currentYear) + currentMonth,
    });

    const searchParamsAdditional = {
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        if (name === 'searchYear' || name === 'searchMonth') {
            const year = name === 'searchYear' ? value : searchParams.searchYear;
            const month = name === 'searchMonth' ? value : searchParams.searchMonth;

            const paddedMonth = String(month).padStart(2, '0');

            const ptmiindt = `${year}${paddedMonth}`;

            newParams.ptmiindt = ptmiindt;

            setSearchParams(newParams);
        }
        setSearchParams(newParams);
    };

    const dataHead = ['번호', '작성자', '작성일시', '대상기관', '지역', '최초조회자', '조회일시', '정보관리 요청내역', '댓글']; //component화 
    const dataColumn = ['RNUM', 'EVL_IN_NAM', 'EVL_WR_DTM', 'EMOGDESC', 'BSCDDESC', 'EVL_RD_NAM', 'EVL_RD_DTM', 'EVL_INFO_COT', 'MSG_CMT'];
    const apiCall = '/ptmiapi/fidelity_msg_data.do';
    const apiCntCall = '';
    const excelFileName = '월별모니터링(정보관리 요청내역)';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: ['3%', '4%', '8%', '15%', '6%', '4%', '8%', '30%', '5%'],
        wrapTF: true
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    // cell onClick state
    const [selectCmt, setSelectCmt] = useState({
        searchEmog: '',
        ptmiindt: '',
        cls: '',
    });

    const { toastModalOpen } = useModalOpen();

    // cell click 사용 시 넘겨줄 props
    const [msgCmt, setMsgCmt] = useState([]);
    const selectCellParams = ['EVL_TGT_EMOG', 'EVL_IN_YYYYMM', 'MSG_CMT'];

    const handleOnClick = (dataList, index, selectCellParams) => {
        setSelectCmt({
            searchEmog: dataList[index][selectCellParams[0]],
            ptmiindt: dataList[index][selectCellParams[1]],
            cls: dataList[index][selectCellParams[2]]
        });
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const modalClose = () => {
        setIsModalOpen(false);
        setMsgCmt();
    };

    // 댓글 확인
    const msgCmtData = async () => {
        try {
            if(selectCmt.cls !== '0') {
                // 백엔드 바인딩 객체가 FidelityMgmtMsg로 바뀌어 파라미터명을 매핑해서 전달
                const response = await axios.get('/ptmiapi/fidelity_msg_cmt_data.do',
                    { params: { evlTgtEmog: selectCmt.searchEmog, evlInYyyymm: selectCmt.ptmiindt } }
                );
                setMsgCmt(response.data);
                setIsModalOpen(true);
            } else {
                setMsgCmt();
                toastModalOpen('확인할 댓글이 없습니다.');
            }
        } catch (error) {
            console.error('상세정보 로딩 중 오류 발생:', error);
        }
    };

    useEffect(() => {
        if(selectCmt.searchEmog !== '') {
            msgCmtData();
        }
    }, [selectCmt]);

    return (
        <Main>
            <MonitoringMsgCmt_layer
                isModalOpen={isModalOpen}
                modalClose={modalClose}
                msgCmt={msgCmt}
            />
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={false}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                            <th>내원기간</th>
                            <td>
                                <select id="searchYear"
                                    name="searchYear"
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 10 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year} 년
                                            </option>
                                        );
                                    })}
                                </select>
                                &ensp;
                                <select id="searchMonth"
                                    name="searchMonth"
                                    value={searchParams.searchMonth}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 12 }, (_, i) => {
                                        const month = (i + 1).toString().padStart(2, '0');
                                        return (
                                            <option key={month} value={month}>
                                                {month} 월
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                selectCellParams={selectCellParams}
                handleOnClick={handleOnClick}
            />
        </Main>
    )
}

export default SendStatMonitoringMsgData;